import { BaseProjectProps, SdbProject } from "@custom-types/project-types";
import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { useProjectMenuOptions } from "@pages/projects/use-project-menu-options";
import { ProjectActionContext } from "@components/common/project-actions";

interface Props extends BaseProjectProps {
  /** Determines on which context the component is being used */
  contextType: ProjectActionContext;
}

/**
 * 3-dot options menu for a project row, providing contextual actions such as
 * view details, open in viewer/HoloBuilder, management, access level,
 * archive/unarchive, share, and delete.
 */
export function ProjectOptionsMenu({
  project,
  contextType,
}: Props): JSX.Element {
  const menuItems = useProjectMenuOptions({ contextType });
  return <ListItemMenu<SdbProject> item={project} menuItems={menuItems} />;
}
